import React, { Fragment, useState, useEffect } from 'react'
import Modal from "../../common/Modal";
import axios from 'axios';
import styles from './CompositeModal.module.sass'
import MultiSelect from '../../common/Forms/MultiSelect';
import SingleSelect from '../../common/Forms/SingleSelect';

const CompositeModal = ({ schoolId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [grade, setGrade] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([])

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const getTeachers = () => {
    axios
      .get(`/api/v1/students/teachers?school_id=${schoolId}`)
      .then((data) => {
        const formattedTeachers = data.data.data.map(datum => ({ value: datum.id, label: datum.name }))
        setTeachers([{ value: 'staff', label: 'Staff' }, ...formattedTeachers])
      })
  }

  const grades = [
    { label: 'PS', value: '-1' },
    { label: 'K', value: '0' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
  ]

  useEffect(() => {
    getTeachers();
  }, [schoolId])

  const formatParams = () => filteredTeachers.join(',');

  const renderModal = () => {
    if (!isOpen) return;

    return (
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Export"
        headerText="Export Composite CSVs"
      >
        <div className={styles.modalBody}>
          <div className={styles.input}>
            <MultiSelect
              handleChange={(e) => { setFilteredTeachers(e.map(teacher => teacher.value)) }}
              options={teachers}
              placeholderText='Select Teachers for Composite'
            />
          </div>

          <div className={styles.input}>
            <SingleSelect
              handleChange={(e) => { setGrade(e.value) }}
              options={grades}
              placeholderText='Select Grades for Composite'
            />
          </div>

          <a
            className='btn btn-primary'
            target='_blank'
            href={`/admin/schools/${schoolId}/composites.zip?teacher_ids=${formatParams()}&grade=${grade}`}>
            Export Composites
          </a>
        </div>
      </Modal>
    )
  }

  return (
    <Fragment>
      {renderModal()}
      <a onClick={openModal} className="btn btn-primary">Export Composite CSV</a>
    </Fragment>
  )
}

export default CompositeModal;
